// @flow
import { ACTIONS } from '../constants';
import setNotificationsAsRead from '../api/setNotificationsAsRead';

const markSingleNotificationAsRead = (id: number) => (dispatch: Function) => {
    setNotificationsAsRead([id]);

    dispatch({
        type: ACTIONS.SINGLE_NOTIFICATION_READ,
        id
    });
};

export default markSingleNotificationAsRead;



// WEBPACK FOOTER //
// ./src/v5/notifications/state/markSingleNotificationAsRead.js